<div class="component-main-container">
  <app-page-header parentTitle="{{ 'logs.logs-parent-label' | translate }}"
    pageTitle="{{ 'logs.form-filter-user' | translate }}">
  </app-page-header>

  <!--Corpo do componente-->
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-logs-form></app-logs-form>

        <div class="form-fields-box" [ngClass]="!filterBox ? 'closed' : ''" [formGroup]="filterLogsForm">
          <h2 (click)="filterBoxOpen()">
            {{ "logs.form-filter-label" | translate }}
          </h2>
          <hr [ngClass]="!filterBox ? 'hr-open' : ''" />

          <div class="form-step">
            <mat-form-field appearance="outline">
              <mat-label>{{ "logs.form-username" | translate}}</mat-label>
              <input matInput formControlName="username" [required]="!filterLogsForm.value.companySelected" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <mat-form-field appearance="outline">
              <mat-label>{{ "logs.form-query-label" | translate }}</mat-label>
              <input matInput formControlName="queryName" />
            </mat-form-field>
          </div>


          <div class="form-step">
            <!-- Campo para realizar a busca das empresas -->
            <mat-form-field appearance="outline">
              <mat-label> {{'logs.form-company' | translate}} </mat-label>
              <input matInput formControlName="company" #companyNameFilter
                [required]="!filterLogsForm.value.username && !filterLogsForm.value.companySelected">
              <mat-icon class="component-search-icon" (click)="searchCompanyFilter(companyNameFilter.value)"
                svgIcon="bx-search"></mat-icon>
            </mat-form-field>
          </div>

          <!-- Loading -->
          @if (companyLoadingFilter) {
          <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
          }

          <!-- Lista das empresas filtradas -->
          @if (companyListFilter.length > 0 ) {
          <div class="form-step">
            <mat-form-field appearance="outline">
              <mat-label> {{'logs.form-select-company' | translate}} </mat-label>
              <mat-select formControlName="companySelected" #value [required]="!filterLogsForm.value.username">
                @for (company of companyListFilter; track company) {
                <mat-option appereance=" outline" [value]="company.id">
                  {{company.name}}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }

          <div class="form-step">
            <div class="date-picker-input">
              <p-datepicker inputId="calendar-24h" selectionMode="range" formControlName="logsDateTime" appendTo="body"
                placeholder="{{ 'logs.form-date' | translate }}" showIcon iconDisplay="input" dateFormat="dd/mm/yy">
              </p-datepicker>
            </div>
          </div>

          @if (!filterLoading) {
          <button title="{{ 'logs.form-filter-button' | translate }}" class="btn btn-success"
            (click)="filterUserTraceLog(null, 10, null)">
            {{ "logs.form-filter-button" | translate }}
          </button>
          }
          @if (filterLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    <!-- Sessão tabela -->
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')" [loadingData$]="fileLoading"></app-table-header>
      @if (filterLoading) {
      <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
      }

      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" [rows]="pageSize" [totalRecords]="length" dataKey="id" [paginator]="true"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="username"> {{ "logs.form-filter-user" | translate }}</th>
              <th pSortableColumn="datetime">{{ "logs.form-logDatetime" | translate }}</th>
              <th pSortableColumn="operation">{{ "logs.form-operation" | translate }}</th>
              <th pSortableColumn="query"> {{ "logs.form-query-label" | translate }}</th>
              <th pSortableColumn="payload"> {{ "logs.form-payload-label" | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{row.user.username}}</td>
              <td>{{formatDate(row.datetime)}}</td>
              <td>{{row.operation | translate }}</td>
              <td>{{row.query}}</td>

              <td>
                <p-button (click)="openDialog(row)" styleClass="btn-actions" [rounded]="true" icon="pi pi-eye" />

              </td>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<ng-template #dialogTemplate let-dialogRef="dialogRef">
  <div class="dialogRef">
    <h2 mat-dialog-title>{{ "logs.form-payload-view" | translate }}</h2>
    <mat-dialog-content class="mat-typography">

      <pre [innerHTML]="choosenPayload"></pre>
      <br>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-flat-button color="success" mat-dialog-close>OK</button>
    </mat-dialog-actions>
  </div>
</ng-template>